export const DEFAULT_MODERATION_LINK = 'https://cdn-p.cian.site/imgmobile/builders/reviews/moderation.pdf';
